enum VALIDATION_MESSAGES {
    REQUIRED = 'To pole jest wymagane',
    
}

export default VALIDATION_MESSAGES;